import axios from 'axios';
// export const API_URL = 'https://digitalapi.o7services.com/';
export const API_URL = 'https://digitalapi.o7services.com/';
//export const API_URL = 'https://17f200e53d04.ngrok-free.app/';

// https://digitalapi.o7services.com/api/user/login
const getToken = () => {
    return sessionStorage.getItem("token");
};
const defaultHeaders = () => {
    const token = getToken();
    return token ? { Authorization: token} : {};
};
const endpoints = {
    login: { method: 'post', url: 'api/user/login', requiresAuth: true },
    getTrainer: { method: 'post', url: 'api/trainer/getall', requiresAuth: true },
    getSingleTrainer:{method:'post', url:"api/trainer/getsingle", requiresAuth:true},
    addTrainer: { method: 'post', url: 'api/trainer/add', requiresAuth: true },
    editTrainer:{method:'post', url:"api/trainer/updateprofile", requiresAuth:true},
    changePassword: { method: 'post', url: 'api/user/changepassword',requiresAuth:true },
    changeStatusTrainer: { method: 'post', url: 'api/trainer/changestatus', requiresAuth: true },
    getStudent:{method:'post', url:"api/student/getall", requiresAuth:true},
    getSingleStudent:{method:'post', url:"api/student/getsingle", requiresAuth:true},
    editStudent:{method:'post', url:"api/student/updateprofile", requiresAuth:true},
    addStudent:{method:'post', url:"api/student/add", requiresAuth:true},
    changeStatusStudent:{method:'post', url:"api/student/changestatus", requiresAuth:true},
    changeStatusBatch:{method:'post', url:"api/batch/changestatus", requiresAuth:true},
    bulkAddStudents:{method:"post",url:"api/manystudent/add", requiresAuth:true},
    bulkStudentRemove:{method:"post",url:"api/studentassign/changeMultipleStudentStatus", requiresAuth:true},
    getBatch:{method:"post",url:"api/batch/getall", requiresAuth:true},
    getSingleBatch:{method:"post",url:"api/batch/getsingle", requiresAuth:true},
    addBatch:{method:"post",url:"api/batch/add", requiresAuth:true},
    assignStudent:{method:"post",url:"api/studentassign/add", requiresAuth:true},
    assignTrainer:{method:"post",url:"api/batch/addanothertrainers", requiresAuth:true},
    getAssignStudent:{method:"post",url:"api/studentassign/getall", requiresAuth:true},
    getAssignStudentPagination:{method:"post",url:"api/studentassign/getpagination", requiresAuth:true},
    getAssignStudentSingle:{method:"post",url:"api/studentassign/getsingle", requiresAuth:true},
    changeStatusAssignStudent:{method:"post",url:"api/studentassign/singleStudentStatusupdate", requiresAuth:true},
    changeStatusAssignTask:{method:"post",url:"api/test/changestatus", requiresAuth:true},
    getSchedule:{method:"post",url:"api/schedule/getpagination", requiresAuth:true},
    addSchedule:{method:"post",url:"api/schedule/add", requiresAuth:true},
    updateScheduleOrder:{method:"post",url:"api/schedule/updateOrder", requiresAuth:true},
    editSchedule:{method:"post",url:"api/schedule/update", requiresAuth:true},
    getTask:{method:"post",url:"api/test/getall", requiresAuth:true},
    getTaskPagination:{method:"post",url:"api/test/getpagination", requiresAuth:true},
    getSingleTask:{method:"post",url:"api/test/getsingle", requiresAuth:true},
    getSingleSchedule:{method:"post",url:"api/schedule/getsingle", requiresAuth:true},
    addTask:{method:"post",url:"api/test/add", requiresAuth:true},
    updateTask:{method:"post",url:"api/test/update", requiresAuth:true},
    getMarks:{method:"post",url:"api/mark/getall", requiresAuth:true},
    updateMarks:{method:"post",url:"api/mark/update", requiresAuth:true},
    assignMarks:{method:"post",url:"api/mark/add", requiresAuth:true},
    updateAssignMarks:{method:"post",url:"api/mark/update", requiresAuth:true},
    bulkAssignMarks:{method:"post",url:"api/mark/addMultipleMarks", requiresAuth:true},
    moveTopic:{method:"post",url:"api/schedule/updateMultipleTopicsWithHistory", requiresAuth:true},
    updateTopicsStatus:{method:"post",url:"api/schedule/updateMultipleTopics", requiresAuth:true},
    trainerDashboard:{method:"post",url:"api/trainerDashboard", requiresAuth:true},
    adminDashboard:{method:"post",url:"api/AdminDashboard", requiresAuth:true},
    postSchedule:{method:"post",url:"api/schedule/postSchedule", requiresAuth:true},
    getLimitedDataStudent:{method:"post",url:"api/student/Getlimitdata", requiresAuth:true},
    studentDashbaord:{method:"post",url:"api/studentdashboard", requiresAuth:true},
    getMaterial:{method:"post",url:"api/material/pagination", requiresAuth:true},
    getSingleMaterial:{method:"post",url:"api/material/getsingle", requiresAuth:true},
    changeStatusSchedule:{method:"post",url:"api/schedule/changestatus", requiresAuth:true},
    removeTrainer:{method:"post",url:"api/studentassign/removeTrainer", requiresAuth:true},
    studentPerformance:{method:"post",url:"api/StudentPerformance", requiresAuth:true},
    studentPerformanceWithTime:{method:"post",url:"api/StudentPerformanceWithTime", requiresAuth:true},
    getSingleUser:{method:"post",url:"api/user/getsingle", requiresAuth:true},
    addMaterial:{method:"post",url:"api/material/add", requiresAuth:true},
    updateMaterial:{method:"post",url:"api/material/update", requiresAuth:true},
    removeAttachment:{method:"post",url:"api/material/removeAttachment", requiresAuth:true},
    deleteMaterial:{method:"post",url:"api/material/delete", requiresAuth:true},
    uploadTask:{method:"post",url:"api/taskUpload/add", requiresAuth:true},
    getUploadedTask:{method:"post",url:"api/taskUpload/pagination", requiresAuth:true},
    // Add more endpoints as needed
};
class ApiServices {
    apiRequest = async (endpointKey, data = null, customHeaders = {}) => {
        const { method, url, requiresAuth } = endpoints?.[endpointKey];
        const headers = requiresAuth ? { ...defaultHeaders(), ...customHeaders } : customHeaders;
        return axios({
            method,
            url: `${API_URL}${url}`,
            data,
            headers
        })
    };
}
export default new ApiServices();
